export default __webpack_public_path__ + "static/media/logo_barra_lateral_blanco.98bc10f9.png";